<template>
  <div class="page">
    <commonHeader heading="数据概览" subtitle="课程数据">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <!-- 所有课程 -->
    <div class="big-title">
      <div class="left-title">所有课程</div>
    </div>
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="请输入课程名称" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="请输入创建人" hide-details solo
            clearable></v-text-field>

          <v-select class="select-width" v-model="queryParams.select" :items="selectMetaListData" label="课程产业群类别"
            color="#4caf50" hide-details solo></v-select>

          <v-menu v-model="dateMenu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="date-width" v-model="queryParams.date1" hide-details solo readonly
                placeholder="课程创建时间" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="zh-cn" v-model="queryParams.date1" @input="dateMenu1 = false"></v-date-picker>
          </v-menu>
          <v-btn depressed color="primary">
            搜索
          </v-btn>
          <v-btn depressed >
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table hide-default-footer :headers="headers" :items="desserts1" :items-per-page="1"
            class="elevation-1"></v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination class="table-pagination" prev-icon="fa fa-angle-left" next-icon="fa fa-angle-right"
            color="#4caf50" :value="pagination.page" :length="1" circle :total-visible="7"></v-pagination>
        </div>
      </v-card>
    </div>

    <!-- 课程热度排行 -->
    <div class="big-title">
      <div class="left-title">课程热度排行</div>
    </div>
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="请输入课程名称" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="请输入创建人" hide-details solo
            clearable></v-text-field>

          <v-select class="select-width" v-model="queryParams.select" :items="selectMetaListData" label="课程产业群类别"
            color="#4caf50" hide-details solo></v-select>

          <v-menu v-model="dateMenu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="date-width" v-model="queryParams.date2" hide-details solo readonly
                placeholder="课程创建时间" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="zh-cn" v-model="queryParams.date2" @input="dateMenu2 = false"></v-date-picker>
          </v-menu>
          <v-btn depressed color="primary">
            搜索
          </v-btn>
          <v-btn depressed >
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table hide-default-footer :headers="headers2" :items="desserts2" :items-per-page="5"
            class="elevation-1"></v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination class="table-pagination"  prev-icon="fa fa-angle-left" next-icon="fa fa-angle-right"
            color="#4caf50" :value="pagination.page" :length="1" circle :total-visible="7"></v-pagination>
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      dateMenu1: false,
      dateMenu2: false,
      selectMetaListData: [{ text: '现代农业', value: 1 },{ text: '教育行业', value: 2 }],

      
      headers: [
        {
          text: '课程名称',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: '课程分类', value: 'val1',sortable: false },
        { text: '工种级别', value: 'val2',sortable: false},
        { text: '创建时间', value: 'val3',sortable: false },
        { text: '开始时间', value: 'val4',sortable: false },
        { text: '结束时间', value: 'val5',sortable: false },
        { text: '课程任务总数', value: 'val6',sortable: false },
        { text: '报名学习人数', value: 'val7',sortable: false },
        { text: '实际学习人数', value: 'val8',sortable: false },
        { text: '课程完学率', value: 'val9',sortable: false },
      ],
      headers2: [
        {
          text: '热搜排名',
          align: 'start',
          sortable: false,
          value: 'index',
        },
        { text: '课程名称', value: 'val1',sortable: false },
        { text: '行业', value: 'val2',sortable: false },
        { text: '工种级别', value: 'val3',sortable: false },
        { text: '浏览学习次数', value: 'val4',sortable: false },
        { text: '课程完学率', value: 'val5',sortable: false },
        { text: '互动讨论人数', value: 'val6',sortable: false },
      ],
      desserts1: [
        {
          name: '无人机驾驶员',
          val1: '现代农业',
          val2: '初级',
          val3: '2024-07-31 17:16:56',
          val4: '2024-07-31 17:16:56',
          val5: '2024-07-31 17:16:56',
          val6: '20',
          val7: '80',
          val8: '80',
          val9: '1.0',
        },
      ],
      desserts2: [
        {
          index: '1',
          val1: '无人机驾驶员',
          val2: '飞行',
          val3: '初级',
          val4: '2000',
          val5: '1.0',
          val6: '800',
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
        // name: "",
        perPageOptions: [8, 12, 16, 20],
      },


    };
  },

  created() {

  },

  mounted() {
    this.getTableList()
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'DataSummary',
      });
    },
    getTableList() { },

  }
}
</script>

<style scoped>
.page {
  padding: 0 15px;

  .big-title {
    display: flex;
    padding: 15px 15px 5px 15px;

    .left-title {    
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-return {
      text-align: right;
      font-size: 18px;
    }
  }

  .table-data {
    .v-card {
      padding: 15px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}
</style>